import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import {
  ClaimRepaymentsPayload,
  DestinationType,
  LockboxPaymentMethod,
  LockboxStatus,
  LockboxType,
  WireStatus,
} from '@/modules/employer/components/Lockbox/lockbox.types';
import { useInvalidateLockbox } from '@/modules/employer/components/Lockbox/LockboxDetails/hooks';

interface RemainderPayload {
  destination_type?: DestinationType;
  remainder_amount?: number;
  benefit_of?: string;
  pay_to?: string;
  address_line1?: string;
  address_line2?: string;
  city?: string;
  state?: string;
  zip?: string;
  account_id?: number;
}

interface LockboxPayload {
  employee_id?: string;
  employee_name?: string;
  organization_id?: number;
  organization_path?: string;
  account_id?: string;
  account_number?: string;
  amount?: string;
  lockbox_type?: LockboxType;
  lockbox_status?: LockboxStatus;
  reason?: string;
  notes?: string;
  vendor_id?: string;
  liquidate_all_funds?: boolean;
  payment_method_type?: LockboxPaymentMethod;
  wire_status_type?: WireStatus;
  remainder?: RemainderPayload;
  claim_repayments?: ClaimRepaymentsPayload[];
}

interface Props {
  lockboxId?: string;
}

const useUpdateLockboxQuery = ({ lockboxId }: Props) => {
  const queryClient = useQueryClient();
  const invalidateLockbox = useInvalidateLockbox(lockboxId);

  const { mutateAsync, isLoading, error } = useMutation(
    (payload: LockboxPayload) => api.patch(API_URL.LOCKBOXES_BY_LOCKBOX_ID(lockboxId as string), payload),
    {
      onSuccess: () => {
        invalidateLockbox();
        queryClient.invalidateQueries({
          queryKey: [API_URL.ACTIVITY_LOGS],
        });
      },
    }
  );

  return {
    updateLockbox: mutateAsync,
    isLoading,
    error,
  };
};

export default useUpdateLockboxQuery;
